module.exports = __webpack_public_path__ + "images/one-of-the-gang-e61202aed4b69a5830e2484e6f313b01.png";